import { render, staticRenderFns } from "./Concluded.vue?vue&type=template&id=197c5b18&scoped=true"
import script from "./Concluded.vue?vue&type=script&lang=js"
export * from "./Concluded.vue?vue&type=script&lang=js"
import style0 from "./Concluded.vue?vue&type=style&index=0&id=197c5b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c5b18",
  null
  
)

/* custom blocks */
import block0 from "./Concluded.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports